
import User from '~/plugins/User';

export default {
  props: {
    id: {
      type: String,
      required: true
    },

    icon: {
      type: String,
      default: 'bell'
    },

    iconOnly: {
      type: Boolean,
      default: false
    },

    objectType: {
      type: String,
      default: 'tender',
      validator: value => ['tender', 'organization'].includes(value)
    }
  },

  data () {
    return {
      isLocalFollowed: false
    };
  },

  computed: {
    list () {
      if (this.objectType === 'tender') {
        return this.$auth.user?.followedTenders?.[this.$user.team.id] ?? [];
      } else if (this.objectType === 'organization') {
        return this.$auth.user?.followedOrganizations?.[this.$user.team.id] ?? [];
      }

      return [];
    },

    isFollowed () {
      return this.isLocalFollowed || this.list.includes(this.id);
    }
  },

  methods: {
    async toggleFollow () {
      this.isLocalFollowed = !this.list.includes(this.id);

      const followed = [...this.list];

      if (this.list.includes(this.id)) {
        await this.$axios.$delete(`user/follow-${this.objectType}/${this.id}`);

        followed.splice(followed.indexOf(this.id), 1);
      } else {
        await this.$axios.$put(`user/follow-${this.objectType}/${this.id}`);

        followed.push(this.id);
      }

      if (this.objectType === 'tender') {
        this.$auth.setUser({
          ...this.$auth.user,
          followedTenders: {
            ...this.$auth.user.followedTenders,
            [this.$user.team.id]: followed
          }
        });
      } else if (this.objectType === 'organization') {
        this.$auth.setUser({
          ...this.$auth.user,
          followedOrganizations: {
            ...this.$auth.user.followedOrganizations,
            [this.$user.team.id]: followed
          }
        });
      }
    }
  }
};
